import mapValues from 'lodash/mapValues'
import { IHealthProcedures, ITimelineGeneral } from '~/interfaces'
import { groupByStartDay, groupByMonth, getMonthName, filterHealthProceduresPer, byTypeExceptAdmission } from '~/utils'

export const mapperTimelineViewByDaysFrom = (
  healthProcedures: IHealthProcedures[]
): ITimelineGeneral.IDailyTimelineData => {
  const healthProceduresWithoutAdmissions = filterHealthProceduresPer(healthProcedures, byTypeExceptAdmission)
  const groupedByDay = groupByStartDay(healthProceduresWithoutAdmissions)

  const groupedDaysStructured = mapValues(groupedByDay, (groupedHealthProcedure: IHealthProcedures[], key: string) => {
    return {
      id: new Date(key).getDate(),
      startDate: key,
      daysRowSlotsTotal: groupedHealthProcedure.length,
      rowSlots: groupedHealthProcedure
    }
  }) as ITimelineGeneral.IDailyRowSlotsWrapper

  const daysGroupedByMonths = groupByMonth(Object.values(groupedDaysStructured))

  const groupedMonthsStructured = mapValues(
    daysGroupedByMonths,
    (dayRegister: ITimelineGeneral.IDailyRowSlotsWrapper[], key: string) => {
      const monthName = getMonthName(dayRegister[0].startDate)

      const monthRowSlotsSunInYear = dayRegister.reduce(
        (acc, day) => (acc = Number(acc) + Number(day.daysRowSlotsTotal)),
        0
      )

      return {
        id: monthName,
        date: key,
        days: dayRegister,
        monthRowSlotsTotal: monthRowSlotsSunInYear
      }
    }
  )

  return {
    timelineId: new Date(healthProcedures[0]?.startDate).getTime(),
    months: Object.values(groupedMonthsStructured)
  }
}
